import { CALL_API } from '../../middleware/api';

export const CREATE_PRODUCT_VERSION_REQUEST = 'CREATE_PRODUCT_VERSION_REQUEST';
export const CREATE_PRODUCT_VERSION_SUCCESS = 'CREATE_PRODUCT_VERSION_SUCCESS';
export const CREATE_PRODUCT_VERSION_FAILURE = 'CREATE_PRODUCT_VERSION_FAILURE';

export const GET_PRODUCT_VERSIONS_REQUEST = 'GET_PRODUCT_VERSIONS_REQUEST';
export const GET_PRODUCT_VERSIONS_SUCCESS = 'GET_PRODUCT_VERSIONS_SUCCESS';
export const GET_PRODUCT_VERSIONS_FAILURE = 'GET_PRODUCT_VERSIONS_FAILURE';

export const GET_PRODUCT_VERSIONS_METADATA_REQUEST = 'GET_PRODUCT_VERSIONS_METADATA_REQUEST';
export const GET_PRODUCT_VERSIONS_METADATA_SUCCESS = 'GET_PRODUCT_VERSIONS_METADATA_SUCCESS';
export const GET_PRODUCT_VERSIONS_METADATA_FAILURE = 'GET_PRODUCT_VERSIONS_METADATA_FAILURE';

export const getProductVersions = () => {
  return {
    [CALL_API]: {
      types: [GET_PRODUCT_VERSIONS_REQUEST, GET_PRODUCT_VERSIONS_SUCCESS, GET_PRODUCT_VERSIONS_FAILURE],
      authenticated: true,
      endpoint: 'product-versions',
      method: 'GET',
    },
  };
};

export const getProductVersionsMetadata = () => {
  return {
    [CALL_API]: {
      types: [GET_PRODUCT_VERSIONS_METADATA_REQUEST, GET_PRODUCT_VERSIONS_METADATA_SUCCESS, GET_PRODUCT_VERSIONS_METADATA_FAILURE],
      authenticated: true,
      endpoint: 'product-versions/metadata',
      method: 'GET',
    },
  };
};

const formatProductVersionForSave = (productVersion) => {
  const data = { ...productVersion };

  const clearEmptyFields = ['locationUsageEventName', 'locationUsageEventType'];
  clearEmptyFields.forEach(field => {
    if (!data[field]) {
      delete data[field];
    }
  });

  return data;
};

export const createProductVersion = (data) => {
  return {
    [CALL_API]: {
      types: [CREATE_PRODUCT_VERSION_REQUEST, CREATE_PRODUCT_VERSION_SUCCESS, CREATE_PRODUCT_VERSION_FAILURE],
      authenticated: true,
      endpoint: 'product-versions',
      method: 'POST',
      payload: formatProductVersionForSave(data),
    },
  };
};
